<template>
  <v-row no-gutters>
    <template v-if="showComplexFees && isArray">
      <v-col cols="12" v-if="filteredFees.length == 1">{{ filteredFees[0].fee | toMoney }}</v-col>
      <template v-else>
        <v-col cols="12" dir="ltr" v-for="f in filteredFees">{{ f.count | toMoney }} x {{ f.fee | toMoney }}</v-col>
      </template>
    </template>
    <v-col cols="12" v-else-if="isArray"> - </v-col>
    <v-col cols="12" v-else>{{ fees }}</v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    fees: {},
    showComplexFees: {},
    warehouses: {
      default: () => []
    },
  },
  computed: {
    isArray() {
      return typeof this.fees == typeof [];
    },
    filteredFees() {
      let fees = [];
      if (this.warehouses && this.warehouses.length && !this.warehouses.includes(0)) {
        this.fees.forEach((fee) => {
          if (this.warehouses.includes(fee.warehouse)) {
            fees.push(fee);
          }
        });
      } else {
        fees = this.fees;
      }
      return fees;
    },
  },
};
</script>

<style lang="scss"></style>
